const safeLocalStorage = (() => {
    // In-memory fallback (used when localStorage is blocked or unavailable)
    const memoryStore = new Map();

    // Detect localStorage availability
    const isAvailable = (() => {
        try {
            const testKey = '__storage_test__';
            window.localStorage.setItem(testKey, '1');
            window.localStorage.removeItem(testKey);
            return true;
        } catch {
            return false;
        }
    })();

    const storage = {
        getItem(key: string) {
            if (isAvailable) {
                try {
                    return window.localStorage.getItem(key);
                } catch {
                    // Fallback if blocked mid-session
                    return memoryStore.get(key) ?? null;
                }
            }
            return memoryStore.get(key) ?? null;
        },

        setItem(key: string, value: string) {
            if (isAvailable) {
                try {
                    window.localStorage.setItem(key, value);
                    return;
                } catch {
                    // fall through to memory store
                }
            }
            memoryStore.set(key, value);
        },

        removeItem(key: string) {
            if (isAvailable) {
                try {
                    window.localStorage.removeItem(key);
                    return;
                } catch {
                    // fall through
                }
            }
            memoryStore.delete(key);
        },

        clear() {
            if (isAvailable) {
                try {
                    window.localStorage.clear();
                    return;
                } catch {
                    // fall through
                }
            }
            memoryStore.clear();
        },

        isLocalStorageAvailable: isAvailable,
    };

    return storage;
})();

export default safeLocalStorage;
